import { DEFAULT_LOCALE } from "@shared/constants";
import { appLocales } from "@shared/i18n";
import { DEFAULT_LS_KEY, localStorageService } from "@shared/services";
import { post } from "@shared/utils/server";

import { ILanguages, TLocale } from "../types";

class LanguageService {
  private isExistedLS = true;

  public async fetchLanguages() {
    const responseLanguagesList = await post({
      method: "Lobby.getLanguages",
      args: {},
    });

    if (
      Array.isArray(responseLanguagesList) &&
      "languages" in responseLanguagesList[0]
    ) {
      return responseLanguagesList[0];
    } else {
      throw new Error("Lobby.getLanguages failure to fetch languages");
    }
  }

  public appAllowLanguageList = (
    languages: ILanguages | null
  ): Array<TLocale> => {
    const langList: TLocale[] = [];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (!languages?.languages) return appLocales as any;
    for (const lang of languages?.languages) {
      langList.push(lang.code);
    }

    return langList.filter((lang) => appLocales.includes(lang));
  };

  public determinateCurrentLanguage = (
    responseData: ILanguages | null
  ): TLocale => {
    const JSONLanguageFromLocalStorage = JSON.parse(
      localStorageService.getData(DEFAULT_LS_KEY) as string
    );

    if (!JSONLanguageFromLocalStorage && !responseData) {
      this.isExistedLS = false;
    }

    if (!responseData && !this.isExistedLS) {
      return DEFAULT_LOCALE;
    }

    if (responseData && !appLocales.includes(responseData?.defaultLang)) {
      return DEFAULT_LOCALE;
    }

    if (responseData && !this.isExistedLS) {
      return responseData?.defaultLang;
    }

    const langFromLS = JSON.parse(
      JSONLanguageFromLocalStorage?.language || JSON.stringify("undefined")
    )?.locale;

    if (
      JSONLanguageFromLocalStorage &&
      responseData &&
      this.isExistedLS &&
      !this.appAllowLanguageList(responseData).includes(langFromLS)
    ) {
      return responseData?.defaultLang;
    }

    return langFromLS;
  };
}

export const languageService = new LanguageService();
